export const getWebAPIUrl = () => {
  return process.env.REACT_APP_WEB_API_URL || '';
};

export const getLogisticsAPIUrl = () => {
  return process.env.REACT_APP_LOGISTICS_API_URL || '';
};

export const getAbsenceAPIUrl = () => {
  return process.env.REACT_APP_ABSENCE_API_URL || '';
};

export const getDelivererApiUrl = () => {
  return process.env.REACT_APP_DELIVERER_API_URL || '';
};
